import React, { useEffect } from 'react'
import LikeButtons from '../LikeButtons/LikeButtons'
import './ImageViewer.scss'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FirebaseHelper } from '../../firebase-helper';

function ImageViewer(props) {
    
    const close = () => {
        props.setVisibility(false)
    }

    return (
        props.visible &&
        <div className="image-viewer">
            {FirebaseHelper.increaseView("wallpapers",props.wallpaper.id)}
            <div onClick={close} className='background'>
            </div>
            <div className='image-container'>
                <img src={props.url} />
                {
                    props.wallpaper.title &&
                    <div className='image-title'>
                        <h2>
                            {props.wallpaper.title}
                        </h2>
                    </div>
                }
            </div>
            <div className='buttons'>
                <button className="cancel-button" onClick={close}>
                    <FontAwesomeIcon icon={faXmark} />
                </button>
                <div className='like-button'>
                    <LikeButtons id={props.wallpaper.id} type="wallpapers" likes={props.wallpaper.likes} dislikes={props.wallpaper.dislikes} clickAble={true} object={props.wallpaper}/>
                </div>
            </div>


        </div>

    )
}

export default ImageViewer